import React, { useState, useEffect } from "react";
import Table from "../../../../Components/UiComponents/Table/Table";
import { useNavigate } from "react-router-dom";
import {
  Editicon,
  Deleteicon,
  PaperClipIcon,
} from "../../../../Components/IconComponents";
import { useDispatch } from "react-redux";
import { viewtaskcolumnsForExportView } from "../../../../JsonData/CreateTaskConfig";
import { setTableData } from "../../../../CentralStore/ExportLMSTable/dataSlice";
import {
  downloadFile,
  getExportedColumnsData,
} from "../../../../Components/UiComponents/utils";
import { getTaskListURL, deleteTaskURL, getActiveMasterSOPList } from "../../../../Services/EndPoints";
import { getData, putDataWithBody } from "../../../../Services/Services";
import Moment from "react-moment";
import { toast } from "react-toastify";
import Confirmpopup from "../../Common/ConfirmPopup/Confirmpopup";
import Loader from "react-spinner-loader";
import { useTranslation } from "react-i18next";
import { OverlayTrigger, Tooltip } from "react-bootstrap"; // Import OverlayTrigger and Tooltip

const ViewTask = () => {
  const [data, setData] = useState([]);
  const [loader, setLoader] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [viewTypeData, setViewTypeData] = useState([]);
  const [incidentTypeData, setIncidentTypeData] = useState([]);
  const [rowCount, setRowCount] = useState(0);
  const [searchData, setSearchData] = useState([]);
  const [checkData, setCheckData] = useState([]);

  useEffect(() => {
    getTaskLists();
    getSOPMasterList();
  }, []);

  useEffect(() => {
    sendDataToCentralStore(searchData);
  }, [searchData]);

  const getShortenedText = (strLength, fulltext) => {
    let abbreviatedText = "";
    if (fulltext.length > strLength) {
      abbreviatedText = fulltext.substring(0, 25) + "...";
    } else {
      abbreviatedText = fulltext;
    }
    return <span title={fulltext}>{abbreviatedText}</span>;
  };
  
  async function getTaskLists() {
    setLoader(true);
    var taskList = await getData(getTaskListURL);
    let sortedList = taskList.sort((a, b) => {
      return new Date(b.created_on) - new Date(a.created_on);
    });
    setLoader(false);
    setData(sortedList);
    setRowCount(sortedList.length);
  }

  const getSOPMasterList = async () => {
    setLoader(true);
    var sopMasterList = await getData(getActiveMasterSOPList);
    let sortedList = sopMasterList.sort((a, b) => {
      return new Date(b.created_on) - new Date(a.created_on);
    });
    setLoader(false);
    setCheckData(sortedList);
  };

  // Function to check if a task name exists in checkData's task_list property
  const isTaskInMasterSOP = (taskName) => {
    if (!taskName || !checkData || checkData.length === 0) return false;
    
    // Check if the task name exists in any of the checkData task_list strings
    return checkData.some(item => {
      if (!item.task_list) return false;
      // Split the task_list string by commas and check if taskName is included
      const taskList = item.task_list.split(',').map(task => task.trim());
      return taskList.includes(taskName);
    });
  };

  function addNewHandler() {
    navigate("/planning/create-task");
  }

  const sendDataToCentralStore = (data) => {
    if (data.length > 0) {
      const columns = viewtaskcolumnsForExportView;
      dispatch(
        setTableData({
          columns,
          tableData: getExportedColumnsData(columns, data),
        })
      );
    }
  };

  const columns = React.useMemo(
    () => [
      {
        Header: t("taskmanagementtableheaders.sopname"),
        accessor: "task_name",
        disableSortBy: true,
        Cell: (props) => {
          if (props.value) {
            return getShortenedText(15, props.value);
          } else {
            return "NA";
          }
        },
      },
      {
        Header: t("taskmanagementtableheaders.incidenttype"),
        accessor: "incident_type",
        disableSortBy: true,
        Cell: (props) => {
          if (props.value) {
            return getShortenedText(15, props.value);
          } else {
            return "NA";
          }
        },
      },
      {
        Header: t("taskmanagementtableheaders.tasktype"),
        accessor: "task_type",
        disableSortBy: true,
      },
      {
        Header: t("taskmanagementtableheaders.assignedto"),
        accessor: "role_name",
        Cell: (props) => {
          if (props.value) {
            return getShortenedText(25, props.value);
          } else {
            return "NA";
          }
        },
        disableSortBy: true,
      },
      {
        Header: t("taskmanagementtableheaders.Createdon"),
        accessor: "created_on",
        disableSortBy: true,
        Cell: (props) => {
          if (props.value) {
            return <Moment format="DD/MM/YYYY, hh:mm a">{props.value}</Moment>;
          } else {
            return "NA";
          }
        },
        disableSortBy: false,
      },
      {
        Header: t("soprelatedtasktableheaders.Viewimage"),
        accessor: "task_file_name",
        disableSortBy: true,
        Cell: ({ value }) =>
          value ? (
            <a href={value} target="_blank" rel="noopener noreferrer">
              <i className="fa fa-eye"></i>
            </a>
          ) : (
            "NA"
          ),
      },
      {
        Header: t("taskmanagementtableheaders.action"),
        disableSortBy: true,
        Cell: (props) => {
          const [isdelete, setIsdelete] = useState(false);
          const deletePopUp = () => {
            setIsdelete(!isdelete);
          };
          const deleteTableDataById = async (id) => {
            let data = { id: id };
            var res = await putDataWithBody(deleteTaskURL, data, {});
            if (res.status == "success") {
              getTaskLists();
            }
            toast.success(res.msg, {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 2000, // Close after 2 seconds
            });
            setIsdelete(false);
          };

          // Check if the task name is in any of the checkData task_list
          const taskName = props.row.original.task_name;
          const isDisabled = isTaskInMasterSOP(taskName);

          // const tooltipMessage = t("Selected Task can't be edited or deleted as it is attached to SOP delete the sop to edit or delete the task");
             const tooltipMessage = t("Editing or deleting this task is not allowed as it is associated with an SOP. Please delete the SOP before making changes.");

          return (
            <div className="usertable__actionsicon">
              {/* Edit Icon with Tooltip */}
              {isDisabled ? (
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip>{tooltipMessage}</Tooltip>}
                >
                  <span>
                    <Editicon 
                      value={props.value} 
                      className="me-2 disabled-icon"
                      style={{ opacity: 0.5, cursor: "not-allowed" }}
                    />
                  </span>
                </OverlayTrigger>
              ) : (
                <span
                  onClick={() => {
                    navigate("/planning/create-task", {
                      state: {
                        data: props.row.original,
                        edit: true
                      },
                    });
                  }}
                >
                  <Editicon 
                    value={props.value} 
                    className="me-2 cursor-pointer"
                  />
                </span>
              )}

              {/* Delete Icon with Tooltip */}
              {isDisabled ? (
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip>{tooltipMessage}</Tooltip>}
                >
                  <span>
                    <Deleteicon
                      value={props.value}
                      className="mr-1 disabled-icon"
                      style={{ opacity: 0.5, cursor: "not-allowed" }}
                    />
                  </span>
                </OverlayTrigger>
              ) : (
                <span onClick={deletePopUp}>
                  <Deleteicon
                    value={props.value}
                    className="mr-1 cursor-pointer"
                  />
                </span>
              )}

              {isdelete && !isDisabled && (
                <Confirmpopup
                  className="DeltePopup"
                  show={isdelete}
                  title={t("deletepopuptext")}
                  message={t("deletepopupmessage")}
                  handleToggle={deletePopUp}
                  row={props.row}
                  name={props.row.original.title}
                  deleteRow={deleteTableDataById}
                  cancel={t("cancelbutton")}
                  action={t("actionbutton")}
                />
              )}
            </div>
          );
        },
      },
    ],
    [t, checkData]
  );

  return (
    <div>
      <div className="create-user">
        <Loader
          show={loader}
          type="body"
          stack="vertical"
          message="Loading Data"
        />
        <div className="datatable__container">
          <Table
            data={data}
            title=""
            addButtonLabel={t("taskaddButtonLabel")}
            addNewHandler={addNewHandler}
            showFilter={false}
            setSearchData={setSearchData}
            columns={columns}
            numberOfRows={10}
            showExport={false}
            showReset={false}
            onExpand={false}
            showSearch={true}
            isHeaderFixed={true}
            rowCount={rowCount}
            headerTableHeadStyle={{ background: "#18a3a0", color: "#FFFFFF" }}
            tableStyle={{
              border: "1px solid #f0f0f0",
              padding: "2px",
              borderRadius: "12px",
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default ViewTask;